export const navigation = {
  CLICK_NAVIGATION: 'navigation.click'
}
